(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('activityFieldDatepicker', activitiesFieldDatepicker);

    function activitiesFieldDatepicker(lodash) {
        return {
            restrict: 'E',
            controller: activitiesFieldDatepickerCtrl,
            controllerAs: 'fieldCtrl',
            bindToController: true,
            require: 'ngModel',
            scope: {
                element: '=',
            },
            templateUrl: 'common/app/components/activities/activity-input/fields/datepicker',
            link: function(scope, elem, attr, ngModelCtrl) {
                var fc = scope.fieldCtrl;
                var dp_object = $(elem).find('.date input');
                var tp_object = elem.find('.time input');
                dp_object.datepicker(fc.dateOptions);
                elem.datepair();

                // var new_date = moment().minutes(0).seconds(0);
                // scope.selected_date = new_date.format(fc.moment_format);
                // scope.selected_time = new_date.format(fc.time_display_format);
                updateUI();


                var timeOptions =  angular.extend(
                    {
                        'showDuration': true,
                        'timeFormat': 'g:i a',

                        // 'minTime': '2:00pm',
                    },
                    lodash.get(scope.element, 'options', {})
                );

                tp_object.timepicker(timeOptions);
                tp_object.timepicker('setTime', new Date());


                function updateDateTime() {
                    var date_str = scope.selected_date + ' ' + scope.selected_time;
                    var date_obj = moment(date_str, fc.moment_format + ' ' + fc.time_display_format);
                    console.log('updateDateTime', date_obj);
                    ngModelCtrl.$setViewValue(date_obj.toISOString());
                }

                function updateUI() {
                    console.log('$render', ngModelCtrl.$viewValue);
                    var new_date;

                    if (!ngModelCtrl.$viewValue) {
                        new_date = moment().minutes(0).seconds(0);
                        scope.selected_date = new_date.format(fc.moment_format);
                        scope.selected_time = new_date.format(fc.time_display_format);
                        updateDateTime();
                    }

                    new_date = moment(ngModelCtrl.$viewValue);

                    dp_object.datepicker('setDate', new_date.format(fc.moment_format));
                    tp_object.timepicker('setTime', new_date.format(fc.time_display_format));
                }


                ngModelCtrl.$render = function() {
                    updateUI();
                }

                ngModelCtrl.$formatters.push(function(modelValue) {
                    return moment(modelValue).minutes(0).seconds(0).toISOString();
                    // console.log(modelValue);
                });

                scope.$watch('selected_date + selected_time', function() {
                    console.log('scope watch');
                    updateDateTime();
                });
            }
        };
    }

    function activitiesFieldDatepickerCtrl(lodash) {
        var fieldCtrl = this;
        this.$onInit = function() {
            // fieldCtrl.kendo_parse_format = lodash.get(fieldCtrl.element, 'options.kendo_parse_format', 'dd/MM/yyyy');
            fieldCtrl.picker_format = lodash.get(fieldCtrl.element, 'options.display_format', 'dd/mm/yyyy');
            fieldCtrl.moment_format = 'DD/MM/YYYY';
            fieldCtrl.time_display_format = 'h:mm a';
            fieldCtrl.time_save_format = 'HH:mm:00';

            fieldCtrl.dateOptions = angular.merge({
                    format: fieldCtrl.picker_format,
                    autoclose: true,
                    forceParse: false,
                    orientation: 'bottom',
                },
                generateOptions()
            );
        }

        function generateOptions() {
            var option = {};
            if (lodash.has(fieldCtrl.element, 'options.max')) {
                var now = lodash.get(fieldCtrl.element, 'options.max.now');
                if (now) {
                    option.endDate = new Date();
                } else {
                    var maxObj = fieldCtrl.element.options.max;
                    option.endDate = new Date(maxObj.year, maxObj.month - 1, maxObj.day);
                }
            }

            if (lodash.has(fieldCtrl.element, 'options.min')) {
                var now = lodash.get(fieldCtrl.element, 'options.min.now');
                if (now) {
                    option.startDate = new Date();
                } else {
                    var minObj = fieldCtrl.element.options.min;
                    option.startDate = new Date(minObj.year, minObj.month - 1, minObj.day);
                }
            }

            return option;
        }


    }
})();
